import { useState, useEffect } from 'react';

/**
 * Hook to detect if a media query matches
 * @param {string} query - CSS media query string (e.g., '(max-width: 767px)')
 * @returns {boolean} - Whether the media query matches
 */
export const useMediaQuery = (query) => {
  // Initialize with false to avoid hydration issues in SSR
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Check if window is defined (SSR safety)
    if (typeof window === 'undefined') return;

    const media = window.matchMedia(query);
    
    // Set initial value
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    // Create listener for changes
    const listener = () => setMatches(media.matches);
    
    // Modern browsers support addEventListener
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      // Fallback for older browsers
      media.addListener(listener);
    }

    // Cleanup
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, [matches, query]);

  return matches;
};

export default useMediaQuery;

